<mat-icon *ngIf="errors.length"
          [class.validation-icon--error]="errorLevel === severityLevel.ERROR"
          [class.validation-icon--warn]="errorLevel === severityLevel.WARN"
          [matTooltipClass]="'tooltip-multiline'"
          [matTooltip]="getErrorMessage()"
          [svgIcon]="svgIconName.WARNING"
          class="error-icon validation-icon">
</mat-icon>
